import React from "react";
import Header from "./include/header";
import Footer from "./include/footer";
import LeftPanel from "./include/LeftPanel";
import { ToastContainer } from '../components/ui/toast';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { ShipmentListContent } from "./Shipments/Shipmentlist";
import { CreateShipmentContent } from "./Shipments/CreateShipment";
import { Package, PackagePlus, PackageCheck, PackageX } from "lucide-react";

/**
 * /Shipping — consolidated Shipping hub (New + All + Undelivered + Delivered)
 * using the shadcn-style Tabs component, replacing four sidebar items.
 * Each list tab keeps the inner status pills (All/Booked/Picked Up/In Transit/
 * Delivered/Cancel/Return) for its scope.
 */
function ShippingPage() {
    return (
        <>
            <LeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <div className="px-content">
                    <h2 className="px-pagehead__title mb-4">Shipping</h2>
                    <Tabs defaultValue="all">
                        <TabsList className="px-tabslist--hub">
                            <TabsTrigger value="all"><Package size={15} /> All Shipments</TabsTrigger>
                            <TabsTrigger value="undelivered"><PackageX size={15} /> Undelivered</TabsTrigger>
                            <TabsTrigger value="delivered"><PackageCheck size={15} /> Delivered</TabsTrigger>
                            <TabsTrigger value="new"><PackagePlus size={15} /> New Shipment</TabsTrigger>
                        </TabsList>
                        <TabsContent value="all">
                            <ShipmentListContent type="All" />
                        </TabsContent>
                        <TabsContent value="undelivered">
                            <ShipmentListContent type="B" />
                        </TabsContent>
                        <TabsContent value="delivered">
                            <ShipmentListContent type="D" />
                        </TabsContent>
                        <TabsContent value="new">
                            <CreateShipmentContent />
                        </TabsContent>
                    </Tabs>
                </div>
                <Footer />
            </main>
        </>
    );
}

export default ShippingPage;
